import { storeStructure } from '../store/reducers';
import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  title: 'Confirmation Page',
  attributeName: 'appDynamicProviderConfirmationForm',
  fields: [
    {
      attributeName: 'confirmationBackground',
      helpText: 'Background image for the confirmation page',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Confirmation Background Image (1440x1024 px)',
      fileType:['image/*','.webp']
    },
    {
      attributeName: 'confirmationBoxBackground',
      helpText: 'Background image for the confirmation box.',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Confirmation Box Background Image (610x681 px)',
      placeholder: 'name...',
      fileType:['image/*','.webp']
    },
    {
      attributeName: 'logo',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Logo (94x74 px)',
      helpText: 'Logo to show in the confirmation page ',
      placeholder: 'Poster URL...',
      fileType:['image/*','.webp']
    },
    {
      attributeName:"sep1",
      type:FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'oculusStoreLink',
      helpText: 'Link to the Oculus store',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Oculus Store Link',
      placeholder: 'https://www.oculus.com/experiences/quest/example/',
    },
    {
      attributeName: 'appleStoreLink',
      helpText: 'Link to the Apple store',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Apple Store Link',
      placeholder: 'https://apps.apple.com/us/app/apple-store/idexample',
    },
    {
      attributeName: 'playStoreLink',
      helpText: 'Link to the Play store',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Play Store Link',
      placeholder: 'https://play.google.com/store/apps/details?id=com.example.app',
    },
    {
      attributeName:"sep1",
      type:FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'header',
      helpText: 'Header of the confirmation page',
      type: FormInputTypes.TEXT_INPUT.TEXT_INPUT,
      label: 'Confirmation Page Header',
      placeholder: 'operation id rename...',
    },
    {
      attributeName: 'message',
      helpText: 'Message to show in the confirmation page',
      type: FormInputTypes.TEXT_EDITOR,
      toolbar:['heading', 'alignment', 'bold', 'italic', 'link'],
      label: 'Confirmation Page Message',
    },
    {
      attributeName:"sep1",
      type:FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'errorHeader',
      helpText: 'Error header of the confirmation page',
      type: FormInputTypes.TEXT_INPUT.TEXT_INPUT,
      label: 'Error Page Header',
      placeholder: 'operation id rename...'
    },
    {
      attributeName: 'errorMessage',
      helpText: 'Error message to show in the confirmation page',
      type: FormInputTypes.TEXT_EDITOR,
      toolbar:['heading', 'alignment', 'bold', 'italic', 'link'],
      label: 'Error Page Message'
    },
  ],
};
